import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
import { MenuItem, Stack, TextField, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { useFormik } from 'formik';
import * as yup from 'yup';
import Page from '../../data/Page';
import { toast } from 'react-toastify';
import { createGame, getGame, updateGame } from '../../services/Common/game.service';
import { useAppContext } from '../../contexts/AppContext';


export default function GameForm({ edit }) {

    const { setLoading } = useAppContext();
    const navigate = useNavigate();
    const { id } = useParams();

    const validationSchema = yup.object({
        title: yup.string().required('Title is required'),
        status: yup.string().required('Status is required field'),
        game_url: yup.string().required('Game url is required')
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            status: '',
            game_url: '',
            landscape_img: null,
            portrait_img: null
        },
        validationSchema,
        onSubmit: async (values) => {
            const formData = new FormData()
            formData.append('title', values.title)
            formData.append('status', values.status)
            formData.append('game_url', values.game_url)
            formData.append('landscape_img', values.landscape_img)
            formData.append('portrait_img', values.portrait_img)
            if (setLoading) {
                setLoading(true);
            }
            try {
                edit ? await updateGame(id, formData) : await createGame(formData);
                toast(`Game ${!edit ? 'Created' : 'Updated'}`, { type: 'success' });
                navigate(Page.GAME);
            } catch (error) {
                console.log(error)
                toast('Some Error occured', { type: 'error' })
            } finally {
                if (setLoading) {
                    setLoading(false);
                }
            }
        },
    });

    useEffect(() => {
        if (id) {
            const GameDetail = async () => {
                const res = await getGame(id);
                // console.log(res)
                formik.setValues(res.data);
            };
            GameDetail();
        }
    }, [id]);



    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Stack spacing={3}>

                    <TextField
                        name="title"
                        label="Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.title}
                        error={formik.touched.title && Boolean(formik.errors.title)}
                        helperText={formik.touched.title && formik.errors.title}
                        variant="filled"
                        size="small"
                        required
                    />

                    <TextField
                        name="status"
                        type="text"
                        label="status"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status}
                        error={formik.touched.status && Boolean(formik.errors.status)}
                        helperText={formik.touched.status && formik.errors.status}
                        variant="filled"
                        size="small"
                        required
                    />

                    <TextField
                        name="game_url"
                        type="url"
                        label="Game Url"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.game_url}
                        error={formik.touched.game_url && Boolean(formik.errors.game_url)}
                        helperText={formik.touched.game_url && formik.errors.game_url}
                        variant="filled"
                        size="small"
                        required
                    />

                    {/* Image field commented for now */}
                    <TextField
                        name="landscape_img"
                        label="Landscape Image"
                        type="file"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="filled"
                        size="small"
                        onChange={(event) => formik.setFieldValue('landscape_img', event.target.files[0])}
                        required={edit ? false : true}

                    />

                    <TextField
                        name="portrait_img"
                        label="Portrait Image"
                        type="file"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="filled"
                        size="small"
                        onChange={(event) => formik.setFieldValue('portrait_img', event.target.files[0])}
                        required={edit ? false : true}

                    />


                    <Stack direction="row" gap={2}>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            size="large"
                            color="primary"
                            disabled={!formik.isValid}
                            loading={formik.isSubmitting}
                        >
                            Submit
                        </LoadingButton>

                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={() => {
                                navigate(Page.GAME);
                            }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Stack>

            </form>
        </>
    );
}
